import { lazy } from 'react'
import type { RouteObject } from 'react-router-dom'

const SetupHubPage = lazy(() => import('./pages/SetupHubPage'))

export const setupHubRoutes: RouteObject[] = [
  {
    path: 'setup-hub',
    element: <SetupHubPage />,
  },
]
